import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableFilterItem, Tabs } from '@lib/ui-components';
import { ServicesSettlement } from './services-settlement/services-settlement';
import { ServicePriceBearer } from '@lib/api-interface';
import { PaginatedInvoices } from './paginated-invoices';

export const MonthEndClosing = () => {
  const { t } = useTranslation();
  const instanceFiltersRef: React.MutableRefObject<TableFilterItem[]> = React.useRef(new Array<TableFilterItem>());

  function updateFiltersIfChanged(filters: Array<TableFilterItem>) {
    instanceFiltersRef.current = filters;
  }

  return (
    <>
      <Tabs
        panels={[
          { label: t('servicesSettlement'), component: <ServicesSettlement /> },
          {
            label: t('incomeInvoices'),
            component: (
              <PaginatedInvoices
                key={'PaginatedInvoices' + new Date().getTime()}
                instanceFiltersRef={instanceFiltersRef}
                bearer={ServicePriceBearer.ORGANIZATION_REVENUE}
                onDefaultFiltersUpdated={(filters) => updateFiltersIfChanged(filters)}
              />
            ),
          },
          {
            label: t('costInvoices'),
            component: (
              <PaginatedInvoices
                key={'PaginatedInvoices' + new Date().getTime()}
                instanceFiltersRef={instanceFiltersRef}
                bearer={ServicePriceBearer.ORGANIZATION_COST}
                onDefaultFiltersUpdated={(filters) => updateFiltersIfChanged(filters)}
              />
            ),
          },
        ]}
      />
    </>
  );
};
